import axios from 'axios'
import api from '../api/index'
import Vue from 'vue'
import { Toast } from 'vant'
import qs from 'qs'
import router from '../router'
import { getToken,
  //TokenLangKey,
  //getTokenbyName, 
  removeToken } from '@/utils/cookies'

Vue.use(Toast)
// 创建axios实例对象
const instance = axios.create({
  baseURL: '/api', // 服务器地址
  timeout: 50000 // 默认超时时长
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.headers = {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' // 设置跨域头部
      }
    }
    const token = getToken()
    if (token) {
      config.headers = {
        Token: token
      }
      config.headers.Authorization = 'Bearer ' + token;
    }
    config.headers = { ...config.headers, Lang: 'zh'}//getTokenbyName(TokenLangKey) }
    return config
  },
  (err) => {
    console.error('请求失败', err)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (res) => {
    
    // 此处对响应数据做处理
    if (res.data.code.toString() == '201') {
      Toast.fail({message:res.data.msg, duration: 2000 })
      return null
    }
    if (res.data.code.toString() == '401') {
      removeToken()
      Toast.fail({message:res.data.msg, duration: 2000 })
      router.push({ path: '/error' })
      return null
    }
    if (res.data.code.toString() == '204') {
      Toast.fail({message:res.data.msg, duration: 2000 })
      return null
    }
    if (res.data.code.toString() != '200') {
      Toast.fail({message:res.data.msg, duration: 2000 })
      return null
    }
    if (res.data.code === 0) {
      Toast.fail({message:res.data.msg, duration: 2000 })
      return null
    }
    Toast.clear();
    return res.data // 该返回对象会传到请求方法的响应对象中
  },
  (err) => {
    console.log(err)
     Toast.clear();
    // 响应错误处理
    return Promise.reject(err)
  }
)

// 封装axios请求方法，参数为配置对象
// option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http (option = {}) {
  Toast.loading({
  message: '加载中...',
  forbidClick: true,
  duration:0
});
  let result = null
  if (option.method === 'get' || option.method === 'delete') {
    // 处理get、delete请求
    await instance[option.method](api[option.url], { params: option.data })
      .then((res) => {
        result = res
      })
      .catch((err) => {
        result = err
      })
  } else if (option.method === 'post' || option.method === 'put') {
    // 处理post、put请求
    await instance[option.method](api[option.url], qs.stringify(option.data))
      .then((res) => {
        result = res
       
        // result.data = JSON.parse(result.data)
      })
      .catch((err) => {
        result = err
      })
  }
   
  return result
}

export default http
